export const getLanguage = () => navigator.language.split('-')[0]
